import { render, staticRenderFns } from "./AnnotationSelection.vue?vue&type=template&id=79f449ca&scoped=true"
import script from "./AnnotationSelection.vue?vue&type=script&lang=js"
export * from "./AnnotationSelection.vue?vue&type=script&lang=js"
import style0 from "./AnnotationSelection.vue?vue&type=style&index=0&id=79f449ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f449ca",
  null
  
)

export default component.exports